import Vue from 'vue';
import VueI18n from 'vue-i18n';
import langEs from '@/lang/dialogs/es.js';
import langEn from '@/lang/dialogs/en.js';
import LocalStorage from 'store';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: LocalStorage.get('lang') || 'es', // set locale
  fallbackLocale: 'es',
  messages: {
    es: langEs, // import(/* webpackChunkName: "lang-es" */ `@/lang/es.json`),
    en: langEn // import(/* webpackChunkName: "lang-en" */ `@/lang/en.json`)
  }
});

export default i18n;
